export default __webpack_public_path__ + "static/media/chick.4b039346.png";